import { useState } from "react";
import {
  changeEmailAuth,
  changePasswordAuth,
  sendEmailVerificationAuth,
} from "@/services/auth/index";
import { updateUser as updateUserService } from "@/services/auth";
import { t } from "i18next";

interface UseUpdateAuthUserInterface {
  changePassword: (password: string) => Promise<void>;
  changeEmail: (userId: number, email: string) => Promise<void>;
  result: boolean | null;
  loading: boolean;
  error: boolean;
}

export const useUpdateAuthUser = (): UseUpdateAuthUserInterface => {
  const [result, setResult] = useState<boolean | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const changePassword = async (password: string): Promise<void> => {
    setLoading(true);
    setError(false);
    setResult(null);
    try {
      await changePasswordAuth(password);
      setResult(true);
    } catch {
      setResult(false);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const changeEmail = async (userId: number, email: string): Promise<void> => {
    setLoading(true);
    setError(false);
    setResult(null);
    try {
      await changeEmailAuth(email);
      const response = await updateUserService({
        userId,
        email,
      });
      if (response.message == "Updated") {
        await sendEmailVerificationAuth();
        setResult(true);
      } else {
        throw new Error(t("common.error"));
      }
    } catch {
      setResult(false);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return { changePassword, changeEmail, result, loading, error };
};
